import { h as y, computed as c, ref as T, onMounted as D, watch as E, createElementBlock as k, openBlock as v, normalizeStyle as Z, normalizeClass as B, unref as $, renderSlot as S, createElementVNode as C, createCommentVNode as A, createVNode as I, mergeProps as G, toDisplayString as O, withModifiers as H, toRaw as Y, inject as ee, nextTick as te, getCurrentInstance as U, getCurrentScope as se, onScopeDispose as ae, toValue as J, shallowRef as oe, onUnmounted as ne, createBlock as N, Teleport as re, TransitionGroup as ie, withCtx as j, Fragment as le, renderList as q, createSlots as ue } from "vue";
var ce = "M8.27,3L3,8.27V15.73L8.27,21H15.73C17.5,19.24 21,15.73 21,15.73V8.27L15.73,3M9.1,5H14.9L19,9.1V14.9L14.9,19H9.1L5,14.9V9.1M11,15H13V17H11V15M11,7H13V13H11V7", de = "M12,2L1,21H23M12,6L19.53,19H4.47M11,10V14H13V10M11,16V18H13V16", fe = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z", me = "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z", pe = "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z";
const ge = {
  transform: "rotate(var(--r, 0deg)) scale(var(--sx, 1), var(--sy, 1))"
}, z = {
  mdi: {
    size: 24,
    viewbox: "0 0 24 24"
  },
  "simple-icons": {
    size: 24,
    viewbox: "0 0 24 24"
  },
  default: {
    size: 0,
    viewbox: "0 0 0 0"
  }
}, ve = {
  props: {
    type: {
      type: String,
      required: !0
    },
    path: {
      type: [String, Object, Array],
      required: !1
    },
    pathString: {
      type: [Array, String, Object],
      required: !1
    }
  },
  setup(t) {
    return () => t.type === "fad" ? (console.warn("vue3-icon does not currently support Duotone FontAwesome icons"), y("path")) : Array.isArray(t.path) ? y(
      "g",
      {
        style: {
          fill: "currentcolor"
        }
      },
      t.path.map((s) => typeof s == "string" ? y("path", { d: s }) : y("path", { ...s }))
    ) : y("path", {
      d: t.pathString,
      style: {
        fill: "currentcolor"
      }
    });
  }
}, R = {
  name: "icon",
  props: {
    /**
     * The icon type, e.g. mdi or simple-icons
     */
    type: {
      type: String,
      default: "mdi"
    },
    /**
     * The FontAwesome icon object
     */
    faIcon: {
      type: Object,
      default: null
    },
    /**
     * The svg path for the icon
     */
    path: {
      type: [String, Object, Array]
    },
    /**
     * The size of the icon when rendered in the browser
     */
    size: {
      type: [Number, String],
      default: 24
    },
    /**
     * The SVG viewbox, affects path position, but not render size
     */
    viewbox: {
      type: String,
      required: !1
    },
    /**
     * Flip the icon either horizontally, vertically, or both
     */
    flip: {
      type: String,
      default: "",
      validator: (t) => ["", "horizontal", "vertical", "both"].includes(t)
    },
    /**
     * Rotate the icon
     */
    rotate: {
      type: [Number, String],
      default: 0
    },
    /**
     * Don't add the XML namespace attribute
     */
    noNamespace: {
      type: Boolean,
      default: !1
    },
    /**
     * Don't add any styles to SVG, disables flip and rotate
     */
    noStyles: {
      type: Boolean,
      default: !1
    },
    /**
     * Don't add the width/height attributes to the SVG element
     */
    noDimensions: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    if (!t.path && !t.faIcon)
      return console.warn("vue3-icon requires either a 'path' or an 'fa-icon' property"), () => y("div");
    const s = c(() => {
      var f;
      return ((f = t.faIcon) == null ? void 0 : f.prefix) || t.type;
    }), o = c(() => parseInt(t.rotate, 10)), e = c(() => z[s.value] || z.default), a = c(() => parseInt(t.size, 10) || e.value.size), r = c(() => t.faIcon ? `0 0 ${t.faIcon.icon[0]} ${t.faIcon.icon[1]}` : !1), l = c(() => r.value || t.viewbox || e.value.viewbox), m = c(() => {
      if (t.noStyles !== !0)
        return {
          ...ge,
          "--sx": ["both", "horizontal"].includes(t.flip) ? "-1" : "1",
          "--sy": ["both", "vertical"].includes(t.flip) ? "-1" : "1",
          "--r": isNaN(o.value) ? o.value : o.value + "deg"
        };
    }), d = c(() => {
      var f;
      return t.faIcon ? (f = t.faIcon) == null ? void 0 : f.icon[4] : t.type === "simple-icons" && typeof t.path == "object" ? t.path.path : t.path;
    });
    return () => y(
      "svg",
      {
        xmlns: t.noNamespace !== !0 ? "http://www.w3.org/2000/svg" : void 0,
        style: m.value,
        class: ["vue3-icon"],
        width: t.noDimensions !== !0 ? a.value : void 0,
        height: t.noDimensions !== !0 ? a.value : void 0,
        viewBox: l.value
      },
      [y(ve, { path: t.path, type: s.value, pathString: d.value })]
    );
  }
}, ye = ["role"], be = { class: "vue3-snackbar-message-wrapper" }, he = {
  key: 0,
  class: "vue3-snackbar-message-icon"
}, ke = { class: "vue3-snackbar-message-content" }, Se = {
  key: 0,
  class: "vue3-snackbar-message-badge"
}, we = { class: "vue3-snackbar-message-title" }, Ce = {
  key: 0,
  class: "vue3-snackbar-message-additional"
}, Me = { class: "vue3-snackbar-message-close" }, Ae = {
  __name: "Vue3SnackbarMessage",
  props: {
    borderClass: {
      type: String,
      default: ""
    },
    message: {
      type: Object,
      default: () => ({})
    },
    messageClass: {
      type: String,
      default: ""
    },
    messageActionClass: {
      type: String,
      default: "vue3-snackbar-message-action"
    },
    dense: {
      type: Boolean,
      default: !1
    },
    iconPresets: {
      type: Object,
      required: !0
    }
  },
  emits: ["dismiss", "click:action"],
  setup(t, { emit: s }) {
    const o = s, e = t;
    let a = null, r = null, l = T(!1);
    const m = () => {
      if ((e.message.duration === 0 || e.message.duration === "0") && e.message.dismissible !== !1)
        return;
      const i = !e.message.duration && !e.message.dismissible ? 4e3 : e.message.duration;
      a = setTimeout(f, i);
    };
    D(m), E(
      () => e.message.count,
      (n) => {
        if (n === 1) return !1;
        clearTimeout(a), clearTimeout(r), r = setTimeout(() => {
          l.value = !1;
        }, 1e3), l.value = !0, m();
      }
    );
    const d = () => {
      a && clearTimeout(a), f();
    }, f = () => {
      o("dismiss", e.message);
    }, w = c(
      () => Object.assign(
        {},
        {
          success: {
            path: fe
          },
          info: {
            path: pe
          },
          warning: {
            path: de
          },
          error: {
            path: ce
          }
        },
        e.iconPresets
      )
    ), b = c(() => {
      const n = w.value[e.message.type];
      return e.message.type && !n && console.warn("[Vue3 Snackbar] Couldn't find icon preset for type " + e.message.type), n ? (n.type = "mdi", n) : e.message.icon && typeof e.message.icon == "object" ? e.message.icon : {
        path: "",
        type: "default"
      };
    }), u = c(() => {
      var n;
      return e.message.type === "error" ? "alert" : ((n = e.message) == null ? void 0 : n.role) ?? "status";
    }), g = {
      name: "RenderedAction",
      render() {
        const n = c(() => Y(e.message.action));
        return n.value ? y(n.value, {
          message: e.message,
          isDismissible: e.message.isDismissible,
          dismiss: d
        }) : null;
      }
    };
    return (n, i) => (v(), k("article", {
      class: B(["vue3-snackbar-message", [
        e.message.type || "custom",
        e.messageClass,
        e.borderClass,
        {
          "has-background": e.message.background,
          "has-border": e.borderClass,
          "is-dense": e.dense,
          "shake-baby-shake": $(l)
        }
      ]]),
      role: u.value,
      style: Z({
        "--message-background": e.message.background,
        "--message-text-color": e.message.textColor,
        "--message-icon-color": e.message.iconColor
      })
    }, [
      S(n.$slots, "message-inner", {
        message: e.message
      }, () => [
        C("div", be, [
          b.value ? (v(), k("div", he, [
            S(n.$slots, "message-icon", {
              message: e.message,
              icon: b.value
            }, () => [
              I($(R), G(b.value, { role: "img" }), null, 16)
            ])
          ])) : A("", !0),
          C("div", ke, [
            S(n.$slots, "message-badge", {
              message: e.message,
              count: e.message.count
            }, () => [
              e.message.count > 1 ? (v(), k("div", Se, O(e.message.count), 1)) : A("", !0)
            ]),
            S(n.$slots, "message-content", {
              message: e.message,
              title: e.message.title,
              text: e.message.text
            }, () => [
              C("div", we, O(e.message.title || e.message.text), 1),
              e.message.title && e.message.text ? (v(), k("div", Ce, O(e.message.text), 1)) : A("", !0)
            ]),
            n.$slots["message-action"] ? (v(), k("div", {
              key: 0,
              class: B(e.messageActionClass),
              onClick: i[0] || (i[0] = H((p) => o("click:action", { message: e.message }), ["stop"]))
            }, [
              S(n.$slots, "message-action", {
                message: e.message,
                isDismissible: e.message.dismissible,
                dismiss: d
              }, () => [
                I(g)
              ])
            ], 2)) : A("", !0)
          ]),
          i[1] || (i[1] = C("div", { class: "spacer" }, null, -1)),
          C("div", Me, [
            S(n.$slots, "message-close-icon", {
              message: e.message,
              isDimissible: e.message.dismissible,
              isDismissible: e.message.dismissible,
              dismiss: d
            }, () => [
              e.message.dismissible !== !1 ? (v(), k("button", {
                key: 0,
                onClick: H(d, ["stop"])
              }, [
                I($(R), {
                  type: "mdi",
                  path: $(me)
                }, null, 8, ["path"])
              ])) : A("", !0)
            ])
          ])
        ])
      ])
    ], 14, ye));
  }
}, Le = typeof window < "u" ? HTMLElement : Object, $e = {
  /* ******************************************
   * LOCATION PROPS
   ****************************************** */
  top: {
    type: Boolean,
    default: !1
  },
  bottom: {
    type: Boolean,
    default: !1
  },
  left: {
    type: Boolean,
    default: !1
  },
  right: {
    type: Boolean,
    default: !1
  },
  /* ******************************************
   * COLOUR PROPS
   ****************************************** */
  success: {
    type: String,
    default: "#4caf50"
  },
  error: {
    type: String,
    default: "#ff5252"
  },
  warning: {
    type: String,
    default: "#fb8c00"
  },
  info: {
    type: String,
    default: "#2196f3"
  },
  iconPresets: {
    type: Object,
    default: () => ({})
  },
  messageTextColor: {
    type: String,
    default: "#fff"
  },
  messageIconColor: {
    type: String,
    default: "currentColor"
  },
  /* *********************************************
   * BACKGROUND PROPS
   * ******************************************* */
  backgroundOpacity: {
    type: [String, Number],
    default: 0.12,
    validator: (t) => !isNaN(parseFloat(t)) && isFinite(t)
  },
  backgroundColor: {
    type: String,
    default: "currentColor"
  },
  baseBackgroundColor: {
    type: String,
    default: "#fff"
  },
  /* *********************************************
   * BEHAVIOUR PROPS
   * ******************************************* */
  duration: {
    type: [Number, String],
    default: null
  },
  reverse: {
    type: Boolean,
    default: !1
  },
  limit: {
    type: Number,
    default: null
  },
  dismissOnActionClick: {
    type: Boolean,
    default: !0
  },
  groups: {
    type: Boolean,
    default: !1
  },
  attach: {
    type: [String, Le],
    default: "body"
  },
  /* ******************************************
   * OTHER PROPS
   ****************************************** */
  border: {
    type: String,
    default: "",
    validator: (t) => ["top", "bottom", "left", "right", ""].includes(t)
  },
  messageClass: {
    type: String
  },
  messageActionClass: {
    type: String,
    default: "vue3-snackbar-message-action"
  },
  zIndex: {
    type: Number,
    default: 1e4
  },
  dense: {
    type: Boolean,
    default: !1
  },
  shadow: {
    type: Boolean,
    default: !1
  },
  contentWidth: {
    type: String,
    default: "min(50vw, 350px)"
  }
};
function xe(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var x = { exports: {} }, P;
function _e() {
  if (P) return x.exports;
  P = 1;
  function t() {
  }
  return t.prototype = {
    on: function(s, o, e) {
      var a = this.e || (this.e = {});
      return (a[s] || (a[s] = [])).push({
        fn: o,
        ctx: e
      }), this;
    },
    once: function(s, o, e) {
      var a = this;
      function r() {
        a.off(s, r), o.apply(e, arguments);
      }
      return r._ = o, this.on(s, r, e);
    },
    emit: function(s) {
      var o = [].slice.call(arguments, 1), e = ((this.e || (this.e = {}))[s] || []).slice(), a = 0, r = e.length;
      for (a; a < r; a++)
        e[a].fn.apply(e[a].ctx, o);
      return this;
    },
    off: function(s, o) {
      var e = this.e || (this.e = {}), a = e[s], r = [];
      if (a && o)
        for (var l = 0, m = a.length; l < m; l++)
          a[l].fn !== o && a[l].fn._ !== o && r.push(a[l]);
      return r.length ? e[s] = r : delete e[s], this;
    }
  }, x.exports = t, x.exports.TinyEmitter = t, x.exports;
}
var V, W;
function Ie() {
  if (W) return V;
  W = 1;
  var t = _e();
  return V = new t(), V;
}
var Oe = Ie();
const _ = /* @__PURE__ */ xe(Oe), M = {
  $on: (...t) => _.on(...t),
  $once: (...t) => _.once(...t),
  $off: (...t) => _.off(...t),
  $emit: (...t) => _.emit(...t)
}, L = T([]), K = Symbol(), Ve = (t) => Math.abs(t.split("").reduce((s, o) => (s << 5) - s + o.charCodeAt(0) | 0, 0));
let F = 1;
M.$on("add", (t) => {
  t = { ...t }, t.group || (t.group = Ve(`${t.type}${t.title}${t.text}`).toString(16)), t.id = F, F++, L.value.push(t);
});
function Ze() {
  const t = ee(K);
  if (!t)
    throw new Error("No Snackbar provided!");
  return t;
}
const Ge = {
  install: (t, s = {}) => {
    const { disableGlobals: o = !1 } = s, e = {
      add: (a) => {
        M.$emit("add", a);
      },
      clear: () => {
        M.$emit("clear");
      }
    };
    o !== !0 && (t.config.globalProperties.$snackbar = e, typeof window < "u" && (window.$snackbar = e)), t.provide(K, e);
  }
};
function Be(t) {
  return se() ? (ae(t), !0) : !1;
}
const Q = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Te = (t) => t != null;
function De(t) {
  return Array.isArray(t) ? t : [t];
}
function Ee(t) {
  return U();
}
function He(t, s = !0, o) {
  Ee() ? D(t, o) : s ? t() : te(t);
}
const Ne = Q ? window : void 0, je = Q ? window.document : void 0;
function qe(t) {
  var s;
  const o = J(t);
  return (s = o == null ? void 0 : o.$el) != null ? s : o;
}
function ze() {
  const t = oe(!1), s = U();
  return s && D(() => {
    t.value = !0;
  }, s), t;
}
function Re(t) {
  const s = ze();
  return c(() => (s.value, !!t()));
}
function Pe(t, s, o = {}) {
  const { window: e = Ne, ...a } = o;
  let r;
  const l = Re(() => e && "MutationObserver" in e), m = () => {
    r && (r.disconnect(), r = void 0);
  }, d = c(() => {
    const u = J(t), g = De(u).map(qe).filter(Te);
    return new Set(g);
  }), f = E(
    () => d.value,
    (u) => {
      m(), l.value && u.size && (r = new MutationObserver(s), u.forEach((g) => r.observe(g, a)));
    },
    { immediate: !0, flush: "post" }
  ), w = () => r == null ? void 0 : r.takeRecords(), b = () => {
    f(), m();
  };
  return Be(b), {
    isSupported: l,
    stop: b,
    takeRecords: w
  };
}
function We(t = {}) {
  const {
    document: s = je,
    selector: o = "html",
    observe: e = !1,
    initialValue: a = "ltr"
  } = t;
  function r() {
    var m, d;
    return (d = (m = s == null ? void 0 : s.querySelector(o)) == null ? void 0 : m.getAttribute("dir")) != null ? d : a;
  }
  const l = T(r());
  return He(() => l.value = r()), e && s && Pe(
    s.querySelector(o),
    () => l.value = r(),
    { attributes: !0 }
  ), c({
    get() {
      return l.value;
    },
    set(m) {
      var d, f;
      l.value = m, s && (l.value ? (d = s.querySelector(o)) == null || d.setAttribute("dir", l.value) : (f = s.querySelector(o)) == null || f.removeAttribute("dir"));
    }
  });
}
const Ue = {
  __name: "Vue3Snackbar",
  props: { ...$e },
  emits: ["added", "group-added", "dismissed", "removed", "cleared", "click:action"],
  setup(t, { emit: s }) {
    const o = We(), e = t, a = s, r = c(() => ({
      "is-top": e.top,
      "is-bottom": e.top === !1 && e.bottom,
      "is-left": e.left,
      "is-right": e.left === !1 && e.right,
      "is-middle": e.top === !1 && e.bottom === !1,
      "is-centre": e.left === !1 && e.right === !1,
      "has-shadow": e.shadow,
      "is-rtl": o.value === "rtl"
    })), l = c(() => ({
      "--success-colour": e.success,
      "--error-colour": e.error,
      "--warning-colour": e.warning,
      "--info-colour": e.info,
      "--snackbar-zindex": e.zIndex,
      "--background-opacity": e.backgroundOpacity,
      "--background-color": e.backgroundColor,
      "--base-background-color": e.baseBackgroundColor,
      "--message-text-color": e.messageTextColor,
      "--message-icon-color": e.messageIconColor,
      "--snackbar-content-width": e.contentWidth
    })), m = c(() => e.border ? `border-${e.border}` : ""), d = (u, g = !1) => {
      a(g ? "dismissed" : "removed", u), L.value = L.value.filter((n) => e.groups ? n.group !== u.group : n.id !== u.id);
    }, f = c(() => {
      const g = [...L.value].reduce((n, i) => {
        e.duration && !i.duration && i.duration !== 0 && (i.duration = +e.duration);
        const p = e.groups ? i.group : i.id;
        if (n.has(p)) {
          const h = n.get(p);
          i.count = h.count + 1, i.id = h.id, n.set(p, i), a("group-added", i);
        } else
          i.count = 1, a("added", i), n.set(p, i);
        return n;
      }, /* @__PURE__ */ new Map());
      return Array.from(g.values());
    }), w = c(() => {
      const u = e.limit ? f.value.slice(e.limit * -1) : f.value;
      return e.reverse ? u.reverse() : u;
    });
    E(
      w,
      (u) => {
        const g = u.map((p) => p.id), i = f.value.map((p) => p.id).filter((p) => !g.includes(p));
        for (const p of i) {
          const h = f.value.find((X) => X.id === p);
          h && d(h, !1);
        }
      },
      {
        immediate: !0
      }
    ), M.$on("clear", () => {
      a("cleared"), L.value = [];
    }), ne(() => {
      M.$off("add"), M.$off("clear");
    });
    const b = (u) => {
      a("click:action", u), e.dismissOnActionClick && d(u.message, !0);
    };
    return (u, g) => (v(), N(re, {
      to: e.attach
    }, [
      C("section", {
        id: "vue3-snackbar--container",
        class: B([[r.value], "vue3-snackbar"]),
        style: Z(l.value),
        "aria-live": "polite"
      }, [
        I(ie, {
          name: "vue3-snackbar-message",
          tag: "div",
          class: "vue3-snackbar--messages"
        }, {
          default: j(() => [
            (v(!0), k(le, null, q(w.value, (n) => (v(), N(Ae, {
              key: n.id,
              message: n,
              "message-class": e.messageClass,
              "message-action-class": e.messageActionClass,
              dense: e.dense,
              "border-class": m.value,
              "icon-presets": e.iconPresets,
              onDismiss: g[0] || (g[0] = (i) => d(i, !0)),
              "onClick:action": b
            }, ue({ _: 2 }, [
              q(u.$slots, (i, p) => ({
                name: p,
                fn: j((h) => [
                  S(u.$slots, p, G({ ref_for: !0 }, h))
                ])
              }))
            ]), 1032, ["message", "message-class", "message-action-class", "dense", "border-class", "icon-presets"]))), 128))
          ]),
          _: 3
        })
      ], 6)
    ], 8, ["to"]));
  }
};
export {
  L as SnackbarMessages,
  Ge as SnackbarService,
  Ue as Vue3Snackbar,
  Ze as useSnackbar
};
